<template>
  <div class="tinymce-wrap">
    <editor v-model="myValue" :init="init"></editor>
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入则不显示编辑器
import 'tinymce/themes/silver' //编辑器主题，不引入则报错
import 'tinymce/icons/default'
// 引入编辑器插件（基本免费插件都在这儿了）
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' //
import 'tinymce/plugins/table' // 插入表格插件
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist' //高级列表
import 'tinymce/plugins/anchor' //锚点
import 'tinymce/plugins/autolink' //自动链接
import 'tinymce/plugins/autoresize' //编辑器高度自适应,注：plugins里引入此插件时，Init里设置的height将失效
import 'tinymce/plugins/autosave' //自动存稿
import 'tinymce/plugins/charmap' //特殊字符
import 'tinymce/plugins/code' //编辑源码
import 'tinymce/plugins/codesample' //代码示例
import 'tinymce/plugins/directionality' //文字方向
import 'tinymce/plugins/preview'
import 'tinymce/plugins/hr'
export default {
  components: {
    Editor,
  },
  name: 'tinymce-editor',
  props: {
    value: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      init: {
        language_url: '/tinymce/langs/zh_CN.js', //引入语言包文件
        language: 'zh_CN', //语言类型
        skin_url: '/tinymce/skins/ui/oxide', //皮肤：浅色
        plugins: 'image media lists table preview ',
        toolbar:
          'undo redo restoredraft | formatselect fontsizeselect | | pastetext | forecolor backcolor bold italic underline strikethrough image axupimgs | alignleft aligncenter alignright alignjustify | \
                      bullist numlist | blockquote subscript superscript removeformat | \
                     table hr',
        // menubar: 'file edit',  //菜单栏配置，设为false则隐藏，不配置则默认显示全部菜单，也可自定义配置--查看 http://tinymce.ax-z.cn/configure/editor-appearance.php --搜索“自定义菜单”
        fontsize_formats:
          '12px 14px 16px 18px 20px 22px 24px 28px 32px 36px 48px 56px 72px', //字体大小
        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;', //字体样式
        lineheight_formats: '0.5 0.8 1 1.2 1.5 1.75 2 2.5 3 4 5', //行高配置，也可配置成"12px 14px 16px 20px"这种形式
        height: this.height, //注：引入autoresize插件时，此属性失效
        placeholder: '在这里输入文字',
        branding: false, //tiny技术支持信息是否显示
        resize: false, //编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
        elementpath: false, //元素路径是否显示
        content_style: 'img {max-width:100%;}', //直接自定义可编辑区域的css样式
        paste_data_images: true,
        images_upload_url: 'https://upload.eiecho.com/uploadEx',
        images_upload_handler: function (blobInfo, success, failure) {
          var xhr, formData
          xhr = new XMLHttpRequest()
          xhr.withCredentials = false
          xhr.open('POST', 'https://upload.eiecho.com/uploadEx')

          xhr.onload = function () {
            var json

            console.log('xhr===', xhr)

            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status)
              return
            }

            json = JSON.parse(xhr.responseText)

            if (!json || typeof json.data.url != 'string') {
              failure('Invalid JSON: ' + xhr.responseText)
              return
            }

            success(json.data.url)
          }

          formData = new FormData()
          formData.append('file', blobInfo.blob())

          xhr.send(formData)
        },
      },
      myValue: this.value,
    }
  },
  mounted() {
    tinymce.init(this.init)
  },
  watch: {
    value: {
      handler: function(newValue, oldValue){
        // console.log('-------------->', newValue)
        this.myValue = newValue
      },
      immediate:true
    },
    myValue(newValue) {
      // console.log(newValue)
      this.$emit('inputChange', newValue)
    },
  },
}
</script>
